<template lang="pug">
div.table_block
  SectionTitle(
    :sectionText='sectionText'
    :displayLayoutOption="displayLayoutOption"
    :displayFilter="displayFilter == null ? true : displayFilter"
    :displaySort="displaySort == null ? true : displaySort"
    :filterType="filterType"
    :listMode="displayList"
    :notBold="notBold"
    @filter="filter"
    @sortByType="sortByType"
    @changeViewMode="changeViewMode"
    @changeType="changeType"
  )
  .sub-title(v-if='isFollowing')
    p.sub-titleWords 如您關注的可疑訊息仍待查核，查證結果將經查核單位查證後，才可直接顯示於頁面中
  div(v-if="displayList")
    table.tableTop10
      TableHeadList(
        :type='type'
        :sortable='isMain ? false : true'
        :headerText='staticData.headerText'
        @sortByType='sortByType'
      )
      TableBodyList(
        v-if='infos && infos.length > 0'
        :type='type'
        :infos='infos'
        :unfolded='unfolded'
        :barBase='barBase'
      )
    .tableTop10-seeMore.show--smallScreens(v-if='isMain && !unfolded && infos.length > 5' @click='unfold')
      span.tableTop10-textSeeMore 展開看更多
      i.icon-caret-down
  div(v-else)
    TableHeadGrid(
      :type='type'
      :headerText='staticData.headerText'
      @sortByType="sortByType"
      :sortable='true'
    )
    TableBodyGrid(v-if="infos && infos.length > 0" :infos="infos")
  TableBodyNoArticle(v-if="(!infos || infos.length == 0)"
    @filter="filter"
    @changeType="changeType"
    :filterType="filterType"
    :text="noArticleText == null ? '搜尋的區間沒有資料，要不要查看其他區間的資料?' : noArticleText"
    :displayOption="displayNoArticleOption == null ? true : displayNoArticleOption"
    :isLoading="isLoading"
  )
  div(v-if="infos && infos.length > 0")
    Pagination(v-if='!isMain' :pageCount='totalPages' @changePage='changePage' :currentPage='localParams.page + 1')
</template>

<script>
import SectionTitle from '@/components/modules/section_title/section_title.vue';
import TableHeadList from '@/components/modules/table_list/table_head.vue';
import TableHeadGrid from '@/components/modules/table_grid/table_head.vue';
import TableBodyList from '@/components/modules/table_list/table_body.vue';
import TableBodyGrid from '@/components/modules/table_grid/table_body.vue';
import TableBodyNoArticle from '@/components/modules/table_list/table_body_no_article.vue';
import Pagination from '@/components/modules/pagination/pagination.vue';
import {
  getParams,
  changeStyle,
  getDate,
  getRouteByParam,
  initLocalParamByQueryStr
} from '@/plugins/tool.js';
import $ from 'jquery';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    SectionTitle,
    TableHeadList,
    TableBodyList,
    TableHeadGrid,
    TableBodyGrid,
    TableBodyNoArticle,
    Pagination,
    Loading
  },
  props: {
    staticData: Object,
    type: String,
    params: Object,
    displayLayoutOption: Boolean,
    displayFilter: Boolean,
    displaySort: Boolean,
    sectionText: String,
    headers: Object,
    langInRoute: Boolean,
    noArticleText: String,
    displayNoArticleOption: Boolean,
    notBold: Boolean
  },
  data() {
    return {
      typeDict: {},
      infos: [],
      barBase: 0,
      localParams: JSON.parse(JSON.stringify(this.params)),
      totalPages: 1,
      unfolded: false,
      filterType: 'all',
      isLoading: false,
      displayOption: true,
      displayList: true
    };
  },
  computed: {
    isMain() {
      return this.$route.path === '/';
    },
    isFollowing() {
      return (
        this.$route.path === '/category' &&
        this.$route.query.type === 'followingArticles'
      );
    }
  },
  async created() {
    this.typeDict.topTen = this.$store.state.routes.topTenArticles;
    this.typeDict.latestArticles = this.$store.state.routes.latestArticles;
    this.typeDict.latestArticlesByCategory = this.$store.state.routes.latestArticlesByCategory;
    this.typeDict.latestArticlesByPartner = this.$store.state.routes.latestArticlesByPartner;
    this.typeDict.verified = this.$store.state.routes.verifiedArticles;
    this.typeDict.followingArticles = this.$store.state.routes.followingArticles;
    this.typeDict.searchArticles = this.$store.state.routes.searchArticles;
    this.typeDict.partnerVerified = this.$store.state.routes.partnerVerified;
    this.typeDict.partnerFollowingArticles = this.$store.state.routes.partnerFollowingArticles;
    this.localParams = initLocalParamByQueryStr(
      this.$route.query,
      this.localParams
    );
    if (this.$route.query.displayList != null) {
      this.displayList =
        this.$route.query.displayList === 'true' ||
        this.$route.query.displayList === true
          ? true
          : false;
    }
    if (this.$route.query.filterType != null) {
      this.filterType = this.$route.query.filterType;
    }
    this.getInfo();
  },
  methods: {
    async getInfo() {
      this.isLoading = true;
      this.infos = [];
      let route = this.$store.state.URLs.api;
      let headers = this.headers;
      if (
        localStorage.getItem(this.$store.state.storageKeys.identity) ==
        'partners'
      ) {
        route = this.$store.state.URLs.apiPartner;
      }
      if (this.langInRoute == false) route += this.typeDict[this.type];
      else route += '/' + this.$store.state.lang + this.typeDict[this.type];
      route = getRouteByParam(this.localParams, route);
      this.$axios
        .get(route, { headers: headers })
        .then(result => {
          this.isLoading = false;
          this.totalPages = result.data.totalPages;
          this.infos = Object.values(result.data.content);
          this.infos.forEach(info => {
            if (info.reporterCount > this.barBase)
              this.barBase = info.reporterCount;
            var date = getDate(info.updatedAt);
            info.updatedAtStr = date.year + '/' + date.month + '/' + date.date;
          });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    sortByType(sortData) {
      changeStyle(sortData);
      var data = JSON.parse(JSON.stringify(sortData));
      if (this.type == 'partnerFollowingArticles')
        data.type = 'article.' + data.type;
      this.localParams = getParams(this.localParams, data);
      this.changePage();
    },
    filter(start, end) {
      if (start === 'all') {
        delete this.localParams.startDate;
        delete this.localParams.endDate;
      } else {
        this.localParams['startDate'] = start.toISOString();
        this.localParams['endDate'] = end.toISOString();
      }
      this.localParams['page'] = 0;
      this.changePage();
    },
    changeViewMode(listMode) {
      this.displayList = listMode;
      this.changePage();
    },
    changePage(page) {
      if (page == null) page = this.localParams.page + 1;
      var link = {
        path: this.$route.path,
        query: JSON.parse(JSON.stringify(this.$route.query))
      };
      this.localParams.page = page - 1;
      link.query.params = JSON.stringify(this.localParams);
      link.query.displayList = this.displayList;
      link.query.filterType = this.filterType;
      this.$router.push(link);
    },
    unfold() {
      this.unfolded = true;
      $('.tableTop10').css('margin-bottom', '40px');
    },
    changeType(filterType) {
      this.filterType = filterType;
    }
  }
};
</script>

<style scoped src="./table_block.vue.css"></style>
